import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Clear';
import { useTranslation } from 'utils/modifiedTranslation';
import * as Redux from 'redux';

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.primary.main,
    fontSize: 16,
    fontWeight: 500,
    padding: '3px 4px',
    textTransform: 'none',
    width: 'fit-content',
    [theme.breakpoints.down('sm')]: {
      fontWeight: 400,
      fontSize: 14,
    },
    '.rtl & span.MuiButton-startIcon': {
      marginLeft: 8,
      marginRight: -4,
    },
  },
  info: {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  infoPopup: {
    position: 'fixed',
    top: 0,
    width: '100%',
    height: '100%',
    transition: 'all 0.4s ease-out',
    background: 'rgba(0, 0, 0, 0.5)',
  },
  infoTitle: {
    fontSize: '18px',
    margin: '0 0 8px',
    lineHeight: 1.6,
    letterSpacing: '0.0075em',
    fontWeight: 500,
  },
  infoContent: {
    fontSize: '16px',
    margin: '0',
    lineHeight: '24px',
    letterSpacing: '0.00938em',
    fontWeight: 500,
    wordBreak: 'break-word',
  },
  infoBox: {
    maxWidth: '600px',
    backgroundColor: 'white',
    padding: '28px 15px',
    borderRadius: '0 0 4px 4px',
  },
  infoIcon: {
    width: '40px',
    height: '40px',
  },
  infoIconClear: {
    color: 'white',
    width: '24px',
    height: '24px',
    backgroundColor: '#ccc',
    borderRadius: '30px',
    margin: '14px 14px 0 0',
    padding: '2px',
    cursor: 'pointer',
  },
  topPopup: {
    height: '15px',
    display: 'flex',
    borderRadius: '4px 4px',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
  },
  infoPopupContent: {
    zIndex: 2,
  },
}));

/**
 * Info section to be displayed beneath a question
 */
const QuestionInfo = (props) => {
  const {
    title, content,
  } = props;
  const { t } = useTranslation();
  const [showPopup, setShowPopup] = useState(false);
  const classes = useStyles();

  const handleClick = () => {
    setShowPopup(true);
  };

  const httpHtml = (contentToReplace) => {
    const reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
    return t(contentToReplace).replace(reg, "<a href='$1$2'>$1$2</a>");
  };
  return (
    <div className={classes.infoWrapper}>
      <Button
        color="primary"
        variant="text"
        className={classes.button}
        onClick={handleClick}
        startIcon={<InfoIcon color="primary" size="small" alt="Info" />}
      >
        {t('question_info.what_did_this_mean')}
      </Button>
      {showPopup ? (
        <div className={classes.info}>
          <div className={classes.infoPopup} onClick={() => setShowPopup(false)} />
          <div className={classes.infoPopupContent}>
            <div className={classes.topPopup}>
              <CloseIcon color="primary" className={classes.infoIconClear} onClick={() => setShowPopup(false)} />
            </div>
            <div className={classes.infoBox}>
              <div>
                <InfoIcon color="primary" size="small" alt="Info" className={classes.infoIcon} />
                <h6 className={classes.infoTitle}>{t(title)}</h6>
                <h6 className={classes.infoContent} dangerouslySetInnerHTML={{ __html: httpHtml(content) }} />
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

QuestionInfo.propTypes = {
  content: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Redux.compose(connect())(QuestionInfo);
